import "./adminDetailsAddComponent.scss";
import FormTitleWithNavigationBack
    from "../../../../shared/components/form-title-with-navigation-back/FormTitleWithNavigationBack";
import React, {useCallback, useEffect, useState} from "react";
import * as Yup from "yup";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import {CommonService} from "../../../../shared/services";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import _ from "lodash";
import {useSearchParams} from "react-router-dom";
import commonService from "../../../../shared/services/common.service";
import Grid from "@mui/material/Grid";
import FormikAutoCompleteDropdown
    from "../../../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import LinkComponent from "../../../../shared/components/link/LinkComponent";
import useRedirectUser from "../../../../shared/hooks/useRedirectUser";
import FeedbackComponent from "../../../../shared/components/feedback/feedbackComponent";

interface AdminDetailsAddComponentProps {
    facilityId: number;
    facilityDetails: any;
    cancel: Function;
    next: Function;
    prev: Function;
}

const validationSchema = Yup.object({
    adminId: Yup.mixed()
        .nullable()
    // .required('Required')
    // .test('is-valid-adminId', 'Invalid adminId', value => {
    //     if (typeof value === 'string') {
    //         return value.trim() !== '';
    //     } else if (typeof value === 'object') {
    //         return value !== null && Object.keys(value).length > 0;
    //     }
    //     return false;
    // }),
});


interface FacilityAdminDetailsFormSchema {
    adminId: string,
}

const formInitialValues: FacilityAdminDetailsFormSchema = {
    adminId: "",
}


const AdminDetailsAddComponent = (props: AdminDetailsAddComponentProps) => {
    const {next, prev, cancel, facilityDetails} = props;
    const {handleRedirectUserModule} = useRedirectUser();

    const [adminDetailsFormInitialValues, setAdminDetailsFormInitialValues] = useState<FacilityAdminDetailsFormSchema>(formInitialValues)
    const [searchParams] = useSearchParams();
    const lastCompletedStep = searchParams.get("lastCompletedStep");
    const [facilityAdminsList, setFacilityAdminsList] = useState<any>([]);
    const [facilityAdminsListLoading, setFacilityAdminsListLoading] = useState<boolean>(false);
    const [facilityAdminListLoadingFailed, setFacilityAdminListLoadingFailed] = useState<boolean>(false);
    const [facilityAdminListLoaded, setFacilityAdminListLoaded] = useState<boolean>(false);


    const onSubmit = useCallback((values: any, {
        setSubmitting,
    }: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = {adminId: values?.adminId?.id || null, lastCompletedStep: lastCompletedStep};
        CommonService._facility.editFacilityDetails(facilityDetails.id, payload)
            .then((response: IAPIResponseType<any>) => {
                next(response?.data);
                setSubmitting(false);
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error.error, "error");
                setSubmitting(false);
            });
    }, [facilityDetails, next, lastCompletedStep]);

    useEffect(() => {
        if (facilityDetails?.adminDetails) {
            const adminDetailsObj = _.cloneDeep(facilityDetails?.adminDetails);
            setAdminDetailsFormInitialValues({adminId: adminDetailsObj});
        }
    }, [facilityDetails]);

    const getFacilityAdminsList = useCallback(() => {
        setFacilityAdminsListLoading(true);
        setFacilityAdminListLoaded(false);
        setFacilityAdminListLoadingFailed(false)
        commonService._facility.getFacilityAdminsList({})
            .then((response: IAPIResponseType<any>) => {
                setFacilityAdminsList(response.data);
                setFacilityAdminListLoaded(true);
                setFacilityAdminsListLoading(false);
            })
            .catch((error: any) => {
                setFacilityAdminListLoadingFailed(true);
                setFacilityAdminsListLoading(false);
            });
    }, [])

    const redirectUser = useCallback(() => {
        handleRedirectUserModule({type: 'facilityAdmin'})
    }, [handleRedirectUserModule])

    useEffect(() => {
        getFacilityAdminsList();
    }, [getFacilityAdminsList]);

    return (
        <div className={'admin-details-add-component screen t-form-screen'}>
            <FormTitleWithNavigationBack
                title={'Admin Details'}
                handleClick={prev}
                tooltipData={"These details relate to the person responsible for administering this facility."}
            />
            <div className="t-form t-form-back-navigation">

                <Formik
                    validationSchema={validationSchema}
                    initialValues={adminDetailsFormInitialValues}
                    validateOnChange={true}
                    validateOnBlur={true}
                    validateOnMount={true}
                    enableReinitialize={true}
                    onSubmit={onSubmit}
                >
                    {({isSubmitting, values, resetForm, isValid, errors, setFieldValue, validateForm}) => {
                        // eslint-disable-next-line react-hooks/rules-of-hooks
                        useEffect(() => {
                            validateForm();
                        }, [validateForm, values]);
                        return (
                            <Form noValidate={true} className={"facility-admin-details-add-holder"}>
                                <div className="t-form-controls-wrapper">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Field name={'adminId'}>
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikAutoCompleteDropdown
                                                            label={'Facility Admin'}
                                                            placeholder={'Select Facility Admin'}
                                                            isDataLoaded={facilityAdminListLoaded}
                                                            isDataLoading={facilityAdminsListLoading}
                                                            isDataLoadingFailed={facilityAdminListLoadingFailed}
                                                            // required={true}
                                                            formikField={field}
                                                            data={facilityAdminsList}
                                                            valueKey={'id'}
                                                            getOptionLabel={(option => commonService.getFullName(option) || '')}
                                                        />
                                                    )
                                                }
                                            </Field>
                                            <div className="redirect-new-link-wrapper">
                                                <div>Didn't find admin?</div>
                                                <LinkComponent className={"redirect-link"}
                                                               onClick={redirectUser}>Create Admin</LinkComponent>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <FeedbackComponent className={"mrg-top-10 mrg-bottom-10"}>
                                                Adding an admin is recommended, but if unavailable, it can be skipped
                                                and added later.
                                            </FeedbackComponent>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className="form-action-section">
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={true}
                                        disabled={isSubmitting}
                                        handleClick={cancel}
                                    >
                                        Close
                                    </ButtonComponent>

                                    <ButtonComponent
                                        type="submit"
                                        color={"primary"}
                                        variant={"contained"}
                                        fullWidth={true}
                                        disabled={!isValid}
                                        isLoading={isSubmitting}
                                    >
                                        Next
                                    </ButtonComponent>
                                </div>

                            </Form>
                        )
                    }
                    }
                </Formik>
            </div>
        </div>
    );
};

export default AdminDetailsAddComponent;
